<template>
    <div>
        <div v-if="tableDatas.length == 0" class="no-data-message" v-t="'message.info_no_billable_information'">
        </div>
        <div v-for="tableData in tableDatas">
            <div class="invoice-titlebox">
                <div class="invoice-titlebox-left" v-t="{ path: 'message.title_billing_information', args: { orderId: tableData.creditOrderId } }"></div>
                <div v-if="isPaidPayment(tableData.creditOrderId)" class="invoice-titlebox-right">
                    <span style="color: #d55169;padding-left: 20px;" v-t="'message.info_billing_from_paid'"></span>
                </div>
                <div v-else class="invoice-titlebox-right">
                    <button v-if="!isPartnerConsole && tableData.paid" class="transparent-button" type="button"
                        v-on:click="downloadReceipt(tableData.billingId, tableData.creditOrderId)">
                        <img src="../assets/icon_download.svg" style="height:16px;vertical-align:middle;padding-right:3px;"/>
                        <span class="normal-command-text" v-t="'message.action_download_receipt'"></span>
                    </button>
                    <button class="transparent-button" type="button" v-on:click="downloadInvoice(tableData.billingId)">
                        <img src="../assets/icon_download.svg" style="height:16px;vertical-align:middle;padding-right:3px;"/>
                        <span class="normal-command-text" v-t="'message.action_invoice_download'"></span>
                    </button>
                </div>
            </div>
            <div class="invoice-table">
                <table width="100%">
                    <tr width="100%">
                        <td class="billing-info-header" v-t="{ path: 'message.item_billing_date', args: { billingDate: convertDatetimeToLocalDate(tableData.billingDatetime) } }"></td>
                        <td rowspan="2" class="billing-total-title" style="text-align:right;padding-right:20px;">
                            <span v-t="'message.item_billing_amount'"/>
                            <span style="font-size:32px;">{{Number(tableData.total + tableData.tax).toLocaleString()}}</span>
                            <span v-t="'message.unit_currency'"/>
                            <span v-if="isIncludingTax()" v-t="'message.item_billing_taxIncluded'"/>
                        </td>
                    </tr>
                    <tr width="100%">
                        <td class="billing-info-header" v-t="{ path: 'message.item_billing_type', args: { billingType: convertPurchasePeriodType(tableData.purchasePeriodType) } }"></td>
                    </tr>
                </table>
            </div>
            <div class="invoice-table">
                <el-table v-if="tableData.purchasedNumberItems.length > 0" :data="tableData.purchasedNumberItems" :default-sort="{prop: 'purchasedDate', order: 'descending'}" style="width: 100%">
                    <!-- el-table-column prop="purchasedDatetime" label="購入日" header-align=left align=center sortable :sort-method="sortByPurchasedDatetime" :formatter="formatDatetime" width="110"></el-table-column -->
                    <el-table-column prop="type" :label="$t('message.item_license_basic')" sortable :sort-method="sortByType" :formatter="formatType"></el-table-column>

                    <el-table-column :label="$t('message.item_usage_period')" header-align=left align=center width="230">
                        <template slot-scope="scope">
                            <div v-if="scope.row.durationStart != null & scope.row.durationEnd != null">
                                {{ convertDatetimeToLocalDate(scope.row.durationStart) }} ~ {{ convertEndDatetimeToLocalDate(scope.row.durationEnd) }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('message.item_unit_price')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            {{ Number(scope.row.unitPrice).toLocaleString() }}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_purchase_count')" header-align=left align=right width="180">
                        <template slot-scope="scope">
                            {{ Number(scope.row.quantity).toLocaleString() }}
                        </template>
                    </el-table-column>
                    <el-table-column v-if="isPartnerConsole" :label="$t('message.item_free_quantity')" header-align=left align=right width="160">
                        <template v-if="scope.row.freeUnit != 0" slot-scope="scope">
                            {{ Number(scope.row.freeUnit).toLocaleString() }}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_amount')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            <div v-if="isDecimalCurrency()">
                                {{ Number(scope.row.amountTotal).toLocaleString() }}
                            </div>
                            <div v-else>
                                {{ Math.floor(scope.row.amountTotal).toLocaleString() }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="tableData.purchasedUsageItems.length > 0" :data="tableData.purchasedUsageItems" :default-sort="{prop: 'purchasedDate', order: 'descending'}" style="width: 100%">
                    <!-- el-table-column prop="purchasedDatetime" label="購入日" header-align=left align=center sortable :sort-method="sortByPurchasedDatetime" :formatter="formatDatetime" width="110"></el-table-column -->
                    <el-table-column prop="type" :label="$t('message.item_license_recurring')" sortable :sort-method="sortByType" :formatter="formatType"></el-table-column>

                    <el-table-column :label="$t('message.item_usage_period')" header-align=left align=center width="230">
                        <template slot-scope="scope">
                            <div v-if="scope.row.durationStart != null & scope.row.durationEnd != null">
                                {{ convertDatetimeToLocalDate(scope.row.durationStart) }} ~ {{ convertDatetimeToLocalDate(scope.row.durationEnd) }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('message.item_unit_price')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            {{ Number(scope.row.unitPrice).toLocaleString() }}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_purchase_count')" header-align=left align=right width="180">
                        <template slot-scope="scope">
                            {{ Number(scope.row.quantity).toLocaleString() }} ({{ Number(scope.row.quantity * getLicenseUnit(scope.row.type)).toLocaleString() + getUnitName(scope.row.type)}})
                        </template>
                    </el-table-column>
                    <el-table-column v-if="isPartnerConsole" :label="$t('message.item_free_quantity')" header-align=left align=right width="160" :filter-method="filterHandlerUsage">
                        <template v-if="scope.row.freeUnit != 0" slot-scope="scope">
                            {{ Number(scope.row.freeUnit).toLocaleString() }} ({{ Number(scope.row.freeUnit * getLicenseUnit(scope.row.type)).toLocaleString() + getUnitName(scope.row.type)}})
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_amount')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            <div v-if="isDecimalCurrency()">
                                {{ Number(scope.row.amountTotal).toLocaleString() }}
                            </div>
                            <div v-else>
                                {{ Math.floor(scope.row.amountTotal).toLocaleString() }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="tableData.purchasedChargeItems.length > 0" :data="tableData.purchasedChargeItems" :default-sort="{prop: 'purchasedDate', order: 'descending'}" style="width: 100%">
                    <!-- el-table-column prop="purchasedDatetime" label="購入日" header-align=left align=center sortable :sort-method="sortByPurchasedDatetime" :formatter="formatDatetime" width="110"></el-table-column -->
                    <el-table-column prop="type" :label="$t('message.item_license_charge')" sortable :sort-method="sortByType" :formatter="formatType"></el-table-column>

                    <el-table-column :label="$t('message.item_usage_period')" header-align=left align=center width="230">
                        <template slot-scope="scope">
                            <div v-if="scope.row.durationStart != null & scope.row.durationEnd != null">
                                {{ convertDatetimeToLocalDate(scope.row.durationStart) }} ~ {{ convertDatetimeToLocalDate(scope.row.durationEnd) }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column :label="$t('message.item_unit_price')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            {{ Number(scope.row.unitPrice).toLocaleString() }}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_purchase_count')" header-align=left align=right width="160">
                        <template slot-scope="scope">
                            {{ Number(scope.row.quantity).toLocaleString() }} ({{ Number(scope.row.quantity * getLicenseUnit(scope.row.type)).toLocaleString() + getUnitName(scope.row.type)}})
                        </template>
                    </el-table-column>
                    <el-table-column v-if="isPartnerConsole" :label="$t('message.item_free_quantity')" header-align=left align=right width="160" :filter-method="filterHandlerUsage">
                        <template v-if="scope.row.freeUnit != 0" slot-scope="scope">
                            {{ Number(scope.row.freeUnit).toLocaleString() }} ({{ Number(scope.row.freeUnit * getLicenseUnit(scope.row.type)).toLocaleString() + getUnitName(scope.row.type)}})
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.item_amount')" header-align=left align=right width="120">
                        <template slot-scope="scope">
                            <div v-if="isDecimalCurrency()">
                                {{ Number(scope.row.amountTotal).toLocaleString() }}
                            </div>
                            <div v-else>
                                {{ Math.floor(scope.row.amountTotal).toLocaleString() }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <table v-if="Number(tableData.tax) == 0" width="100%" style="margin-bottom: 60px;">
                <tr>
                    <td class="billing-total-title" v-t="'message.item_total'"></td>
                    <td class="billing-total-value" style="font-weight: 700">{{ Number(tableData.total + tableData.tax).toLocaleString() }}</td>
                </tr>
            </table>
            <table v-else width="100%" style="margin-bottom: 60px;">
                <tr>
                    <td class="billing-total-title" v-t="'message.item_sub_total'"></td>
                    <td class="billing-total-value" width="140px">{{ Number(tableData.total).toLocaleString() }}</td>
                </tr>
                <tr>
                    <!---td class="billing-total-title" v-t="{ path: 'message.item_consumption_tax', args: { taxRate: Number(tableData.taxRate)*100 }}"></td--->
                    <td class="billing-total-title" v-t="'message.item_consumption_tax_noRate'"></td>
                    <td class="billing-total-value">{{ Number(tableData.tax).toLocaleString() }}</td>
                </tr>
                <tr>
                    <td class="billing-total-title" v-t="'message.item_total'"></td>
                    <td class="billing-total-value" style="font-weight: 700">{{ Number(tableData.total + tableData.tax).toLocaleString() }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import commonUtil from './commonutil.js';
import constants from './constants.js';
import server from "./ServerApi.js";
import parnerserver from "./PartnerServerApi.js";

export default {
    data() {
      return {
        tableDatas: []
      };
    },
    methods: {
        onChange(billingInfos) {
            this.tableDatas = [];
            for (let i = 0; i < billingInfos.length; i++) {
                const billingInfo = billingInfos[i];
                let purchasedItems = JSON.parse(billingInfo.jsonData).billingItems;
                let purchasedNumberItems = [];
                let purchasedUsageItems = [];
                let purchasedChargeItems = [];
                for (let purchasedItem of purchasedItems) {
                    switch(purchasedItem.type) {
                        case constants.LICENSE_USER:
                        case constants.LICENSE_SPEECH_TEXT:
                        case constants.LICENSE_TRANSLATION:
                        case constants.LICENSE_CONFIG:
                        case constants.LICENSE_ACCESS_LOG:
                        case constants.LICENSE_TRACKING:
                        case constants.LICENSE_MAP_TALK:
                        case constants.LICENSE_HISTORY_RETENTION:
                        case constants.LICENSE_HISTORY_RETENTION_ADVANCED:
                        case constants.LICENSE_HISTORY_RETENTION_TRACKING:
                        case constants.LICENSE_VIDEO:
                        case constants.LICENSE_SAML:
                        case constants.OFF_PLAN_LICENSE_BELL:
                        case constants.OFF_PLAN_LICENSE_DEDICATED:
                        case constants.OFF_PLAN_LICENSE_CALL_CENTER:
                        case constants.OFF_PLAN_LICENSE_BUDDY_BOT_API:
                        case constants.OFF_PLAN_LICENSE_MAP_IMAGE_OVERLAY:
                        case constants.OFF_PLAN_LICENSE_CALL:
                        case constants.OFF_PLAN_LICENSE_SAFETY_SUPPORT:
                        case constants.LICENSE_PLAN_TALK_LITE:
                        case constants.LICENSE_PLAN_TALK_ENT:
                        case constants.LICENSE_PLAN_LIVE_LITE:
                        case constants.LICENSE_PLAN_LIVE_ENT:
                        case constants.PLAN_UPGRADE_TL_TE:
                        case constants.PLAN_UPGRADE_TL_LL:
                        case constants.PLAN_UPGRADE_TL_LE:
                        case constants.PLAN_UPGRADE_TE_LE:
                        case constants.PLAN_UPGRADE_LL_LE:
                            purchasedNumberItems.push(purchasedItem);
                            break;
                        case constants.RECURRING_SPEECH_TEXT:
                        case constants.RECURRING_TRANSLATION:
                        case constants.RECURRING_DATA_TRANSFER:
                            purchasedUsageItems.push(purchasedItem);
                            break;
                        case constants.CHARGE_SPEECH_TEXT:
                        case constants.CHARGE_TRANSLATION:
                        case constants.CHARGE_DATA_TRANSFER:
                            purchasedChargeItems.push(purchasedItem);
                            break;
                    }
                }

                purchasedNumberItems.sort((a, b) => {
                    // プランを上に持ってくる
                    if (a.type >= 1000 && b.type >= 1000) {
                        return a.type - b.type;
                    }
                    if (a.type >= 1000) {
                        return -1;
                    }
                    if (b.type >= 1000) {
                        return 1;
                    }
                    return a.type - b.type;
                })
                purchasedUsageItems.sort((a, b) => {
                    return a.type - b.type;
                })
                purchasedItems.sort((a, b) => {
                    return a.type - b.type;
                })

                this.tableDatas.push (
                    {
                        billingId: billingInfo.billingId,
                        billingDatetime: billingInfo.billingDatetime,
                        creditOrderId: billingInfo.creditOrderId,
                        purchasePeriodType: billingInfo.purchasePeriodType,
                        purchasedNumberItems: purchasedNumberItems,
                        purchasedUsageItems: purchasedUsageItems,
                        purchasedChargeItems: purchasedChargeItems,
                        total: billingInfo.total,
                        tax: billingInfo.tax,
                        taxRate: billingInfo.taxRate,
                        paid: billingInfo.paid,
                        planNameOverride: billingInfo.planNameOverride
                    }
                )
            }
        },
//        sortByPurchasedDatetime(a,b) {
//            const dateA = new Date(a.purchasedDatetime);
//            const dateB = new Date(b.purchasedDatetime);
//            return dateA.getTime() - dateB.getTime();
//        },
        sortByType(a,b) {
            return a.type - b.type;
        },
        formatType(row, column) {
            if (row.planNameOverride) {
               return row.planNameOverride;
            }
            return commonUtil.getLicenseName(this.$i18n, row.type);
        },
        formatDatetime(row, column) {
            return this.convertDatetimeToLocalDate(row.purchasedDatetime);
        },
        convertDatetimeToLocalDate(datetime) {
            const dateObj = new Date(datetime);
            const year = dateObj.getFullYear();
            const month = dateObj.getMonth() + 1;
            const date = dateObj.getDate();
            return year + '-' + (month < 10 ? '0' : '') + month + '-' + (date < 10 ? '0' : '') + date;
        },
        convertEndDatetimeToLocalDate(datetime) {
            const dateObj = new Date(datetime);
            dateObj.setDate(dateObj.getDate() -1);
            const year = dateObj.getFullYear();
            const month = dateObj.getMonth() + 1;
            const date = dateObj.getDate();
            return year + '-' + (month < 10 ? '0' : '') + month + '-' + (date < 10 ? '0' : '') + date;
        },
        convertPurchasePeriodType(type) {
           return commonUtil.getPurchasePeriodTypeName(this.$i18n, type);
        },
        getLicenseUnit(type) {
           return commonUtil.getLicenseUnit(type);
        },
        getUnitName(type) {
           return commonUtil.getUnitName(this.$i18n, type);
        },
        downloadInvoice(billingId) {
            let self = this;
            let input = {billingId : billingId, language : this.$i18n.locale};
            let apiserver = this.isPartnerConsole ? parnerserver : server;
            apiserver.downloadBlob('/downloadinvoice', input)
            .then((res) => {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const downloadFileName = 'buddycom_invoice_' + billingId + '.pdf';
                commonUtil.downloadFile(blob, downloadFileName)
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "downloadInvoice", error);
            });
        },
        downloadReceipt(billingId, creditOrderId) {
            let self = this;
            if (creditOrderId === undefined){
                commonUtil.notifyMessage(self, "Warning", "銀行振り込みのため領収書のダウンロードはできません。");
                return;
            }
            let input = {billingId : billingId, language : this.$i18n.locale};
            let apiserver = this.isPartnerConsole ? parnerserver : server;
            apiserver.downloadBlob('/downloadreceipt', input)
                .then((res) => {
                    const blob = new Blob([res.data], { type: 'application/pdf' });
                    const downloadFileName = 'buddycom_receipt_' + billingId + '.pdf';
                    commonUtil.downloadFile(blob, downloadFileName)
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "downloadReceipt", error);
                });
        },
        isDecimalCurrency() {
            if (this.tenantCurrency == constants.CURRENCY_YEN) {
                return false;
            } else {
                return true;
            }
        },
        isIncludingTax() {
            return (this.appData.countryCodeAlpha3 == "JPN")
        },
        isPaidPayment(orderId) {
            if (!orderId) {
                return false;
            }

            return commonUtil.isPaidOrderId(orderId);
        },
    },
    created: function() {
        this.onChange(this.billingInfos);
    },
    components: {
        currencyYen: function() {
            return true;
            /*
            if (this.appData.countryCodeAlpha3 == "JPN") {
                return true;
            } else {
                return false;
            }
            */
        }
    },
    watch: {
        billingInfos: {
            handler(newVal, oldVal) {
                this.onChange(newVal);
            }
        }
    },
    props: ['billingInfos', 'isPartnerConsole', 'appData' , 'tenantCurrency' ]
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.invoice-titlebox {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
}
.invoice-titlebox-left {
    padding: 10px 0 10px 28px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.invoice-titlebox-right {
    padding: 10px 28px 10px 28px;
    position: relative;
    width: 50%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
    font-size: 12px;
}
.billing-info-header {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
}
.billing-total-title {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: right;
}
.billing-total-value {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 40px;
    width: 140px;
    text-align: right;
}
.invoice-table {
    margin: 20px 30px;
    min-width: 630px;
}
.invoice-table >>> .el-table {
    color: inherit;
}
.invoice-table >>> .el-table th {
    padding-top: 0px;
    padding-bottom: 0px;
    color: #848991;
    font-size: 12px;
    font-weight: normal;
    background-color: #f1f3f7;
}

.invoice-table >>> .el-table--enable-row-hover .el-table__body tr:hover>td {
    background-color: transparent;
}
.invoice-table >>> .el-table .cell {
    padding-left: 20px;
}
</style>
